import { DSButtonV2 } from '@elliemae/ds-button';
import { memo } from 'react';
import { MANAGE_EXCEPTION_LABEL } from '../utils/constants';

interface ManageExceptionButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const ManageExceptionButtonComponent = ({
  onClick,
  disabled = false,
}: ManageExceptionButtonProps) => (
  <DSButtonV2
    buttonType="outline"
    size="s"
    disabled={disabled}
    onClick={onClick}
    data-testid="manage-exception-button"
  >
    {MANAGE_EXCEPTION_LABEL}
  </DSButtonV2>
);

export const ManageExceptionButton = memo(ManageExceptionButtonComponent);
